export default "__VITE_ASSET__n9pzBQ26__"